import { Users2 } from "lucide-react";
import { STAGE_META } from "./FunnelChart";
import {
  CLASS_BG, CLASS_DOT, STAGE_ICONS, DeltaTag, fmtNumber,
} from "./PerfSharedUI";

/**
 * Single funnel stage card. Clickable — opens the drill-down panel for
 * the given stage.
 */
export default function StageCard({
  stageKey, count, delta, classification, extraLabel, extraValue, onClick, testid,
}) {
  const Icon = STAGE_ICONS[stageKey] || Users2;
  const cls = classification || "unknown";
  const stage = STAGE_META.find((s) => s.key === stageKey);
  return (
    <button
      onClick={onClick}
      className={`text-left rounded-2xl border-2 p-5 hover:shadow-md transition-all ${CLASS_BG[cls]}`}
      data-testid={testid}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="w-9 h-9 rounded-lg bg-card/60 border border-white flex items-center justify-center">
          <Icon className="w-4 h-4 text-foreground" strokeWidth={1.5} />
        </div>
        <span className={`w-2 h-2 rounded-full ${CLASS_DOT[cls]}`} />
      </div>
      <div className="text-[10px] uppercase tracking-[0.15em] text-muted-foreground font-semibold">
        {stage?.label}
      </div>
      <div className="font-display text-3xl text-foreground tracking-tight mt-1">
        {fmtNumber(count)}
      </div>
      {extraLabel !== undefined && (
        <div className="mt-1.5 text-xs text-muted-foreground">
          <span className="font-semibold text-foreground">{extraValue}</span> {extraLabel}
        </div>
      )}
      <div className="mt-2">
        <DeltaTag delta={delta} />
      </div>
    </button>
  );
}
